// extracted by mini-css-extract-plugin
var _1 = "BlockStar__img--_m5kP";
var _2 = "BlockStar__main--BPLqY";
var _3 = "BlockStar__main2--Gce67";
var _4 = "BlockStar__main3--weBXt";
var _5 = "BlockStar__mainNoHighlight--RzQR1 BlockStar__main--BPLqY";
var _6 = "BlockStar__shadow--fgDqj";
var _7 = "BlockStar__svg--z0TaF";
export { _1 as "img", _2 as "main", _3 as "main2", _4 as "main3", _5 as "mainNoHighlight", _6 as "shadow", _7 as "svg" }
